<script>
import { sendAudio, createGroup } from 'api/index'
import { getScreenSize } from 'common/js/dom'
import { getUrlParam, buriedSubmit } from 'common/js/common'
import {
  isBxs,
  isTrueToBApp,
  isWeCom,
  isWeEnterprise,
  isMiniBankInsurance
} from 'base/config'
import { BottomSheets } from 'bxs-ui-vue'
import OpenLaunch from 'components/openLaunch'
export default {
  name: 'SchemeSelection', // 讲解方案选择
  components: {
    [BottomSheets.name]: BottomSheets,
    OpenLaunch
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isSupportRecordScreen: {
      type: Boolean,
      default: false
    },
    miniprogram: {
      type: Boolean,
      default: false
    },
    interactionOn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const typeOptions = []
    if (this.interactionOn && (!this.miniprogram || isMiniBankInsurance)) {
      typeOptions.push({label: '同屏讲解', value: 0})
    }
    if (this.isSupportRecordScreen) {
      typeOptions.push({label: '录屏讲解', value: 1})
    }
    if (isBxs) {
      typeOptions.push({label: '动画讲解', value: 2})
    }
    const typeVal = typeOptions[0] ? typeOptions[0].value : null
    return {
      isWeEnterprise,
      typeVal,
      typeOptions,
      init: false,
      wxBtnConfig: {},
    }
  },
  computed: {
    isShow: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    isShow (val) {
      if (!val) return
      buriedSubmit('jiangjie')
      if (!this.init) {
        this.isWeEnterprise && this.initData()
      }
    }
  },
  methods: {
    async initData () {
      try {
        const titleStr = '为您推荐计划书'
        const uuid = getUrlParam('uuid')
        const theme = getUrlParam('theme')
        const {
          data: { data: roomId }
        } = await this.createRoom(uuid)
        if (!roomId) {
          this.$messagebox.alert('获取讲解房间号失败')
          return
        }
        const btnWidth = getScreenSize().width - 30
        const path = `pages/invitation/index?uuid=${uuid}&roomId=${roomId}&theme=${theme}&title=${titleStr}&app=tob`
        this.wxBtnConfig = {
          originalId: 'gh_db166d39960f',
          path: path,
          content: `
            <button class="weapp-btn">确定</button>
            <style>
              .weapp-btn {
                display: block;
                width: ${btnWidth}px;
                padding: 7px 68px 8px;
                margin: 7px auto;
                color: #fff;
                font-size: 15px;
                font-weight: bold;
                text-align: center;
                border-radius: 6px;
                border: 0!important;
                outline: 0!important;
                background-color: #e58800;
              }
            </style>
          `
        }
        this.init = true
      } catch (err) {
        console.log(err)
      }
    },
    createRoom (uuid) {
      return createGroup({ pbUuid: uuid })
    },
    handleTypeChanges (value) {
      if (this.typeVal === value) return
      this.typeVal = value
    },
    handleDetermine () {
      const { miniprogram, typeVal } = this
      const action = isBxs
            ? 'share'
            : (isTrueToBApp || isWeCom || isWeEnterprise || miniprogram)
            ? 'wechat-invitation'
            : 'invitation'
      switch (typeVal) {
        case 0:
          buriedSubmit('tongping')
          this.handleClick(action)
          break
        case 1:
          buriedSubmit('luping')
          this.handleClick(isBxs ? 'began-to-record-screen' : 'record-screen')
          break
        case 2:
          this.handleClick('audio-visual')
          buriedSubmit('donghua')
          this.jumpToAudioVisual()
          break
        default:
      }
    },
    handleClick (type) {
      this.$emit(type)
      switch (type) {
        case 'share':
        case 'invitation':
          window.WeiyiStatSDK.submit('tongping')
          break
        case 'began-to-record-screen':
        case 'record-screen':
          window.WeiyiStatSDK.submit('luping')
          break
        case 'audio-visual':
          window.WeiyiStatSDK.submit('JHS_ST')
          break
        default:
      }
      this.isShow = false
    },
    // 动画讲解
    jumpToAudioVisual () {
      const uuid = getUrlParam('uuid')
      sendAudio({ uuid }).then(({ data: { success } } = {}) => {
        if (!success) return
        window.location.href = `https://pbf.winbaoxian.${
          /pbf\.winbaoxian\.com/.test(window.location.hostname) ? 'com' : 'cn'
        }/planbook-innovative/?uuid=${uuid}&common=true&resultType=audio`
      })
    }
  }
}
</script>
<template>
  <!-- 讲解方案 -->
  <bxs-bottom-sheets
    v-model="isShow"
    class="pdf-bottom-sheets"
    height="middle"
    title="选择讲解类型"
    :prevent-scroll-through="true"
  >
    <div class="scheme-tour">
      <ul class="type-options">
        <li
          v-for="(item, index) in typeOptions"
          :key="index"
          @click="handleTypeChanges(item.value)"
        >
          <div class="img-wrapper">
            <label class="my-radio-icon-wrap">
              <input
                v-model="typeVal"
                class="input"
                type="radio"
                name="type"
                :value="item.value"
              >
              <bxs-icon name="circle" />
              <bxs-icon name="circle-dot" />
              <span class="radio-text">{{ item.label }}</span>
            </label>
          </div>
        </li>
      </ul>
      <div v-if="typeVal === 0" class="scheme-option">
        <div class="hd">
          <h5>同屏讲解</h5>
          <p>同屏操作，实时查看</p>
        </div>
        <div class="bd">
          <div class="diagram">
            <img
              src="https://img.winbaoxian.com/bxs/images/tp1614564483987.gif"
              alt="步骤"
            >
          </div>
          <ul class="step-list">
            <li><i>1</i>点击下方“确定”按钮分享给客户</li>
            <li><i>2</i>请客户在微信中打开同屏讲解</li>
            <li><i>3</i>进入微信开始讲解产品</li>
          </ul>
        </div>
      </div>
      <div
        v-else-if="typeVal === 1 && isSupportRecordScreen"
        class="scheme-option"
      >
        <div class="hd">
          <h5>录屏讲解</h5>
          <p>录屏讲解，保存相册</p>
        </div>
        <div class="bd">
          <div class="diagram">
            <img
              src="https://media.winbaoxian.com/autoUpload/common/a3cd1612-9b16-400b-ab1b-e02b0b1f3f4a.png"
              alt="步骤"
            >
          </div>
          <ul class="step-list">
            <li><i>1</i>点击下方“确定”按钮录制讲解视频</li>
            <li><i>2</i>录制完需您授权相册、悬浮按钮等权限</li>
            <li><i>3</i>授权完成，可以保存相册，也可立刻发送给客户</li>
          </ul>
        </div>
      </div>
      <div v-else-if="typeVal === 2" class="scheme-option">
        <div class="hd">
          <h5>动画讲解</h5>
          <p>能说会动，直观易懂</p>
        </div>
        <div class="bd">
          <div class="diagram">
            <img
              src="https://media.winbaoxian.com/autoUpload/common/b491ef0f-fdbd-4bc7-b540-7aa7f31cda27.png"
              alt="步骤"
            >
          </div>
          <ul class="step-list">
            <li><i>1</i>点击下方“确定”按钮动画讲解产品</li>
            <li><i>2</i>点击转发，直接将视听计划书发送给客户</li>
          </ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="bottom-link">
      <!-- 微信小程序开放标签 -->
      <open-launch
        v-if="isWeEnterprise && init"
        class="btn share"
        :infor="wxBtnConfig"
      />
      <a
        v-else
        class="to-table-report"
        href="javascript:;"
        @click="handleDetermine"
      >确定</a>
    </div>
  </bxs-bottom-sheets>
</template>
<style lang="postcss" scoped>
.pdf-bottom-sheets {
  z-index: 702;
}
.type-options {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
  > li {
    flex: 1;
  }
}
.my-radio-icon-wrap {
  display: block;
  text-align: left;

  .bx-icon-circle,
  .bx-icon-circle-dot {
    font-size: 18px;
    width: 18px;
    pointer-events: none;
    vertical-align: middle;
    color: #ccc;
  }

  .bx-icon-circle-dot {
    display: none;
  }

  .input {
    display: none;

    &:checked ~ .bx-icon-circle {
      display: none;
    }

    &:checked ~ .bx-icon-circle-dot {
      display: inline-block;
    }

    &[disabled='disabled'] ~ i {
      color: #ccc;
    }
  }

  .radio-text {
    margin-left: 4px;
    font-size: 12px;
    vertical-align: middle;
    pointer-events: none;
  }
}

.scheme-list {
  font-size: 0.32rem;
  padding: 0.3rem 0.5rem;
  .scheme-item {
    display: flex;
    padding-top: 0.16rem;
    margin-bottom: 0.64rem;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .scheme-hd {
    flex: 1.08rem 0 0;
    padding-right: 0.36rem;
    > img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .scheme-bd {
    flex: 1;
    line-height: 1;
    > h5 {
      margin-bottom: 0.18rem;
      font-size: 0.3rem;
      font-weight: bold;
    }
    > p {
      font-size: 0.28rem;
      color: #999;
    }
    &:after {
      border-color: #ccc;
    }
  }
}
.scheme-tour {
  padding: 0.3rem;
  font-size: 0.28rem;
  .scheme-option {
    .hd {
      position: relative;
      display: flex;
      margin-bottom: 0.25rem;
      align-items: flex-end;
      &::before {
        z-index: 1;
        position: absolute;
        left: -0.02rem;
        bottom: 0.03rem;
        content: '';
        width: 1.48rem;
        height: 0.11rem;
      }
    }
    h5 {
      z-index: 2;
      position: relative;
      color: #333;
      font-size: 0.34rem;
      font-weight: bold;
    }
    p {
      padding-left: 0.16rem;
      font-size: 0.24rem;
      color: #999;
    }
    .bd {
      border: 1px solid #e6e6e6;
      border-radius: 0.12rem;
      p {
        font-size: 0.24rem;
        color: #999;
      }
    }
    .step-list {
      padding-left: 0.3rem;
      margin: 0.23rem 0;
      font-size: 0.24rem;
      li {
        position: relative;
        margin-bottom: 0.18rem;
        padding-left: 0.48rem;
        color: #999;
        &:last-child {
          margin-bottom: 0;
        }
      }
      i {
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        width: 0.36rem;
        height: 0.36rem;
        line-height: 0.36rem;
        border-radius: 100%;
        color: #fff;
        font-size: 0.24rem;
        background-color: #333;
        text-align: center;
      }
    }
    .diagram {
      position: relative;
      overflow: hidden;
      border-top-left-radius: 0.12rem;
      border-top-right-radius: 0.12rem;
      padding-bottom: 60.6%;
      > img {
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        border-radius: 0.12rem;
      }
    }
  }
}
</style>
